import React, { useEffect, useState } from "react";
import { ChevronDown, Code, Palette, Sparkles } from "lucide-react";
import profile from "../assets/trans.png";


const Hero = () => {
  const [mousePosition, setMousePosition] = useState({ x: 0, y: 0 });

  useEffect(() => {
    const handleMouseMove = (e) => {
      setMousePosition({ x: e.clientX, y: e.clientY });
    };

    window.addEventListener('mousemove', handleMouseMove);
    return () => window.removeEventListener('mousemove', handleMouseMove);
  }, []);

  const scrollToAbout = () => {
    const element = document.getElementById('about');
    if (element) {
      element.scrollIntoView({ behavior: "smooth" });
    }
  };

  return (
    <section id="hero" className="min-h-screen flex items-center justify-center bg-gradient-to-br from-[#F8F9FA] to-[#A9D6E5]/20 dark:from-gray-900 dark:to-gray-800 pt-16 relative overflow-hidden transition-colors duration-300">
      {/* Animated background particles */}
      <div className="absolute inset-0 overflow-hidden">
        <div className="absolute top-20 left-10 w-2 h-2 bg-[#E6B566]/30 rounded-full animate-float"></div>
        <div className="absolute top-40 right-20 w-3 h-3 bg-[#3A7CA5]/20 rounded-full animate-float animation-delay-1000"></div>
        <div className="absolute bottom-40 left-20 w-4 h-4 bg-[#A9D6E5]/40 rounded-full animate-float animation-delay-2000"></div>
        <div className="absolute top-60 right-40 w-2 h-2 bg-[#E6B566]/20 rounded-full animate-float animation-delay-3000"></div>
      </div>

      {/* Mouse follower */}
      <div 
        className="fixed w-6 h-6 border border-[#3A7CA5]/30 rounded-full pointer-events-none z-10 transition-transform duration-100"
        style={{
          left: mousePosition.x - 12,
          top: mousePosition.y - 12,
          transform: `translate(0, 0) scale(${mousePosition.x > 0 ? 1 : 0})`,
        }}
      ></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10">
        <div className="grid lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div className="text-center lg:text-left animate-slideInLeft">
            <div className="flex items-center justify-center lg:justify-start gap-2 mb-4 group">
              <Code className="w-6 h-6 text-[#3A7CA5] group-hover:rotate-12 transition-transform duration-300" />
              <span className="text-[#3A7CA5] dark:text-[#A9D6E5] font-medium">Software Engineering Student</span>
              <Sparkles className="w-4 h-4 text-[#E6B566] animate-pulse" />
            </div>
            
            <h1 className="text-4xl md:text-6xl font-bold text-[#3D3D3D] dark:text-white mb-6">
              Hi, I'm{" "}
              <span className="relative text-[#3A7CA5] dark:text-[#A9D6E5] inline-block">
                <span className="relative z-10">Kinandaru</span>
                {/* Signature animated underline */}
                <div className="absolute -bottom-2 left-0 w-full h-1 bg-gradient-to-r from-[#3A7CA5] to-[#E6B566] transform origin-left animate-expandWidth"></div>
              </span>
            </h1>
            
           <p className="text-lg text-gray-600 dark:text-gray-300 mb-8 max-w-2xl animate-slideInLeft animation-delay-300">
  Saya adalah seorang pelajar SMK dengan jurusan Rekayasa Perangkat Lunak yang berfokus pada 
  pengembangan web fullstack serta perancangan antarmuka pengguna dengan Figma. 
  Mari berkolaborasi untuk menciptakan solusi teknologi yang bermanfaat dan berdampak nyata.
</p>

            <div className="flex flex-col sm:flex-row gap-4 justify-center lg:justify-start animate-slideInLeft animation-delay-500">
              <button 
  onClick={scrollToAbout}
  className="group px-8 py-3 bg-[#3A7CA5] text-white rounded-lg ..."
>
  <span className="relative z-10">Pelajari Lebih Lanjut Tentang Saya</span>

                <div className="absolute inset-0 bg-gradient-to-r from-[#2E6B94] to-[#3A7CA5] opacity-0 group-hover:opacity-100 transition-opacity duration-300"></div>
                <div className="absolute -top-2 -right-2 w-4 h-4 bg-white/20 rounded-full group-hover:scale-150 group-hover:opacity-0 transition-all duration-300"></div>
              </button>
              <button 
                onClick={() => document.getElementById('projects').scrollIntoView({ behavior: 'smooth' })}
                className="group px-8 py-3 border-2 border-[#3A7CA5] dark:border-[#A9D6E5] text-[#3A7CA5] dark:text-[#A9D6E5] rounded-lg hover:bg-[#3A7CA5] dark:hover:bg-[#A9D6E5] hover:text-white dark:hover:text-gray-900 transition-all duration-300 transform hover:scale-105 hover:-rotate-1 relative overflow-hidden"
              >
                <span className="relative z-10">Lihat Karya Saya</span>
                <div className="absolute inset-0 bg-[#3A7CA5] dark:bg-[#A9D6E5] transform -translate-x-full group-hover:translate-x-0 transition-transform duration-300"></div>
              </button>
            </div>

            {/* Skills Preview with enhanced animations */}
            <div className="mt-12 flex flex-wrap justify-center lg:justify-start gap-3 animate-slideInLeft animation-delay-700">
              {['React', 'Laravel', 'Figma', 'JavaScript', 'MySQL'].map((skill, index) => (
                <span 
                  key={skill} 
                  className="px-4 py-2 bg-white dark:bg-gray-800 text-[#3A7CA5] dark:text-[#A9D6E5] rounded-full text-sm font-medium shadow-md hover:shadow-xl transform hover:scale-110 hover:-translate-y-1 transition-all duration-300 cursor-pointer group"
                  style={{ animationDelay: `${index * 100}ms` }}
                >
                  <span className="group-hover:text-[#E6B566] transition-colors duration-200">{skill}</span>
                </span>
              ))}
            </div>
          </div>

          {/* Right Content - Enhanced Illustration with Profile Image */}
          <div className="relative flex justify-center lg:justify-end animate-slideInRight">
            <div className="relative">
              {/* Main circle with enhanced animations */}
              <div className="w-80 h-80 bg-gradient-to-tr from-[#A9D6E5]/30 to-[#E6B566]/30 dark:from-[#3A7CA5]/20 dark:to-[#E6B566]/20 rounded-full flex items-center justify-center relative animate-pulse-slow group hover:scale-105 transition-transform duration-500">
                {/* Rotating ring */}
                <div className="absolute inset-0 border-2 border-[#3A7CA5]/20 rounded-full animate-spin-slow"></div>
                
                <div className="w-60 h-60 rounded-full overflow-hidden shadow-2xl relative hover:shadow-3xl transition-shadow duration-300">
                  <img 
                    src={profile} 
                    alt="Profile" 
                    className="w-full h-full object-cover" 
                  />

                  {/* Floating elements around the circle */}
                  <div className="absolute -top-4 -right-4 w-8 h-8 bg-[#3A7CA5] rounded-full flex items-center justify-center shadow-lg animate-bounce-slow">
                    <Code className="w-4 h-4 text-white" />
                  </div>
                  <div className="absolute -bottom-4 -left-4 w-6 h-6 bg-[#E6B566] rounded-full flex items-center justify-center shadow-lg animate-bounce-slow animation-delay-1000">
                    <Palette className="w-3 h-3 text-white" />
                  </div>
                </div>
              </div>
              
              {/* Additional floating elements */}
              <div className="absolute top-10 -right-6 w-12 h-12 bg-[#A9D6E5]/20 rounded-lg rotate-45 animate-float"></div>
              <div className="absolute bottom-10 -left-6 w-8 h-8 bg-[#E6B566]/20 rounded-full animate-float animation-delay-2000"></div>
            </div>
          </div>
        </div>

        {/* Enhanced Scroll Indicator */}
        <div className="absolute bottom-8 left-1/2 transform -translate-x-1/2">
          <button onClick={scrollToAbout} className="group animate-bounce-gentle">
            <div className="flex flex-col items-center">
              <span className="text-xs text-[#3A7CA5] dark:text-[#A9D6E5] mb-2 opacity-70 group-hover:opacity-100 transition-opacity duration-200">Scroll Down</span>
              <ChevronDown className="w-6 h-6 text-[#3A7CA5] dark:text-[#A9D6E5] group-hover:translate-y-1 transition-transform duration-200" />
            </div>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Hero;